import { Application } from '@hotwired/stimulus'

// Aplicación de Stimulus única para toda la página.
//
// Los packs se cargan DENTRO del <turbo-frame id="content">: layouts/application.haml mete
// el contenido en el frame, _estructura_application_base renderiza desde ahí el partial
// head_metadata (el nombre engaña: no está en el <head>) y este acaba incluyendo los packs.
// Turbo vuelve a ejecutar los scripts del fragmento que reemplaza, así que cada navegación
// por el sitio re-evalúa el pack entero.
//
// Antes, cada evaluación llamaba a Application.start() y registraba de nuevo sus
// controladores. El resultado era una aplicación de Stimulus por navegación, cada una
// conectando SU controlador sobre los mismos elementos: dos navegaciones, tres controladores
// vivos sobre el mismo editor. En el editor del foro eso significaba un listener de mención
// por salto y, al elegir una sugerencia, tantas menciones insertadas como navegaciones
// llevara el usuario — el fallo de TDT-RNK-3942, donde tres saltos daban tres menciones.
//
// La instancia y el registro de identificadores viven en `window` a propósito: el ámbito de
// módulo se pierde en cada re-evaluación, que es justo lo que hay que sobrevivir.
export function stimulusApplication () {
  if (!window.Stimulus) {
    const application = Application.start()
    application.debug = false

    window.Stimulus = conRegistroUnico(application)
  }

  return window.Stimulus
}

// Registrar dos veces el mismo identificador conecta un segundo controlador sobre cada
// elemento que lo declare. Ante una re-evaluación conservamos el primero: el elemento ya
// está conectado a él y la clase de la segunda evaluación es equivalente.
//
// Se envuelve `register` en lugar de exponer una función aparte para que la guarda cubra
// también a quien no pase por aquí: controllers/index.js lo genera `stimulus:manifest:update`
// y llama a `application.register` directamente, así que no puede depender de que el autor
// del pack se acuerde.
function conRegistroUnico (application) {
  const registrados = new Set()
  const registrar = application.register.bind(application)

  application.register = (identificador, controlador) => {
    if (registrados.has(identificador)) return

    registrados.add(identificador)
    registrar(identificador, controlador)
  }

  return application
}
